export const buildAcademyTrainingPath = (urlSegment: string, sectionPath: string, id: string | number) => {
    const sectionPrefix = sectionPath ? `/${sectionPath}` : '';
    return `/${urlSegment}${sectionPrefix}/training/${id}`;
};
